"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b)
                if (Object.prototype.hasOwnProperty.call(b, p))
                    d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
require("@rmlibrary/slider/src/custom-element.js");
var Focus = require("./focus.js");
var custom_elements_1 = require("@rmlibrary/custom-elements");
var utilities_js_1 = require("./utilities.js");
var accessibility_js_1 = require("./accessibility.js");
var throttle_js_1 = require("./throttle.js");
var RMCPControlsElement = /** @class */ (function (_super) {
    __extends(RMCPControlsElement, _super);
    function RMCPControlsElement() {
        var _this = _super.call(this) || this;
        // boolean properties
        _this.allowIndicators = false; // determines if indicators should be shown when video is played/paused
        _this.preventClickAction = false; // prevents doubleclick from playing/pausing video (should only allow for fullscreen/exit full screen mode)
        _this.hideControls = true; // tracks if the controls should be hidden
        _this.isSeeking = false; // allows for the handling of play/pause when video is seeking
        _this.resumePlay = false; // tracks if the video was playing before seeking in order to resume playing on release of slider-handle (if true, resume playing, if false, leave paused)
        _this.touchDevice = false; // tracks if the device has a touchscreen
        // allows for manipulation of captions/transcript
        _this.formatTranscript = function (str) { return str; };
        _this.transcriptHTMLRef = null; // holds a reference to the transcript HTML
        _this.transcriptHTMLContainerSelector = "";
        _this.transcriptHTMLUrl = "";
        _this.transcriptWindowFeatures = null;
        // seekbar options (allows user to jump frames using keyboard and seekbar)
        _this.sliderOptions = {
            min: 0,
            max: 1000,
            value: 0,
            keyStep: function (direction, isJump, slider) {
                var delta = ((isJump ? 20 : 5) * 1000) / _this.duration;
                return direction > 0 ? slider.value + delta : slider.value - delta;
            },
            valueText: function () {
                try {
                    var t = Math.round(_this.player.getCurrentTime());
                    return "".concat((0, utilities_js_1.formatTimeA11y)(t), " of ").concat((0, utilities_js_1.formatTimeA11y)(_this.duration));
                }
                catch (e) {
                    return "0";
                }
            },
        };
        // player controls timer
        _this.playerControlsTimeout = 3000;
        _this.playerControlsTimer = 0;
        _this.clickActionDelay = 500;
        _this.clickActionTimer = 0;
        /*
         * the following property allows for customization of action on end of animation
         * options: stop, stopNoReplayBtn, loop, restart (see onEnd function)
         */
        _this.endAction = "stopNoReplayBtn"; // stopNoReplayBtn is the default
        // adds a timeout on how often the player calls goToFrame on change (used in change handler)
        _this.throttleGoToFrame = (0, throttle_js_1.throttle)(function (frame) { return _this.player.goToFrame(frame); }, 50, false);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleControlsKeyDown = _this.handleControlsKeyDown.bind(_this);
        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
        _this.handleRmSliderDown = _this.handleRmSliderDown.bind(_this);
        _this.handleRMSliderChange = _this.handleRMSliderChange.bind(_this);
        _this.handleRMSliderUp = _this.handleRMSliderUp.bind(_this);
        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        _this.handleFocusIn = _this.handleFocusIn.bind(_this);
        _this.handleFocusOut = _this.handleFocusOut.bind(_this);
        _this.handleDblClick = _this.handleDblClick.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    // function to handle play/pause on video when the spacebar key is pressed
    RMCPControlsElement.prototype.handleKeyDown = function (event) {
        if ((0, accessibility_js_1.isTabbable)(event.target)) {
            return;
        }
        if (event.key === " " || event.key === "Spacebar") {
            this.togglePlay(false, true);
            this.cpContainer.focus();
            this.hideControls = true;
            /*
             * Prevents the browser default behaviour of the page scrolling
             * down when the spacebar key is pressed.
             */
            event.preventDefault();
        }
    };
    // check if browser supports full screen mode
    RMCPControlsElement.prototype.isFullscreenSupported = function () {
        var document = window.document;
        return document.fullscreenEnabled ||
            document.mozFullScreenEnabled ||
            document.msFullscreenEnabled ||
            document.webkitFullscreenEnabled
            ? true
            : false;
    };
    RMCPControlsElement.prototype.connectedCallback = function () {
        this.cpContainer = this.querySelector(".cp-container"); // container for the canvas player
        this.thumbnail = this.querySelector(".cp-thumbnail"); // thumbnail to show when video has been loaded
        this.overlay = this.querySelector(".cp-overlay"); // overlay for adding buttons
        this.preloader = this.querySelector(".cp-preloader");
        this.playIndicator = this.querySelector(".cp-play-indicator");
        this.pauseIndicator = this.querySelector(".cp-pause-indicator");
        this.lrgPlayBtn = this.querySelector(".cp-large-play");
        this.lrgReplayBtn = this.querySelector(".cp-large-replay");
        this.controlsContainer = this.querySelector(".cp-controls-container"); // container for the captions and controls
        this.captions = this.querySelector(".cp-captions");
        this.playerControls = this.querySelector(".cp-controls"); // container for the controls (all buttons)
        this.playBtn = this.querySelector(".cp-play");
        this.replayBtn = this.querySelector(".cp-replay");
        this.pauseBtn = this.querySelector(".cp-pause");
        this.currentTimeText = this.querySelector(".current-time");
        this.durationText = this.querySelector(".duration");
        this.seekBar = this.querySelector(".cp-seekbar");
        this.showCaptionsBtn = this.querySelector(".cp-show-captions");
        this.hideCaptionsBtn = this.querySelector(".cp-hide-captions");
        this.transcriptBtn = this.querySelector(".cp-transcript");
        this.fullScreenBtn = this.querySelector(".cp-fullscreen");
        this.exitFullScreenBtn = this.querySelector(".cp-exit-fullscreen");
        this.seekBarHandle = this.querySelector(".rm-slider-handle");
        this.captionsEmpty = this.captions.innerText === "" ? true : false;
        this.fullScreenSupported = this.isFullscreenSupported();
        // Add listeners
        // play/pause the video when the spacebar key is pressed
        document.addEventListener("keydown", this.handleKeyDown);
    };
    RMCPControlsElement.prototype.disconnectedCallback = function () {
        // Remove listeners
        this.removeEventListeners();
    };
    // update property this.allowIndicators
    RMCPControlsElement.prototype.toggleIndicators = function (allowIndicators) {
        this.allowIndicators = allowIndicators;
    };
    RMCPControlsElement.prototype.resetIndicator = function (event) {
        event.target.classList.remove("fade-out");
        event.target.classList.add("hide");
        event.target.removeEventListener("animationend", this.resetIndicator);
    };
    // toggle between play/pause btn
    RMCPControlsElement.prototype.togglePlay = function (preventFocus, showIndicator) {
        var _a, _b;
        if (preventFocus === void 0) {
            preventFocus = false;
        }
        if (showIndicator === void 0) {
            showIndicator = false;
        }
        if (!((_a = this.thumbnail) === null || _a === void 0 ? void 0 : _a.classList.contains("hide"))) {
            (_b = this.thumbnail) === null || _b === void 0 ? void 0 : _b.classList.add("hide");
        }
        if (!this.lrgPlayBtn.classList.contains("hide")) {
            this.lrgPlayBtn.classList.add("hide");
        }
        if (!this.lrgReplayBtn.classList.contains("hide")) {
            this.lrgReplayBtn.classList.add("hide");
        }
        if (!this.replayBtn.classList.contains("hide")) {
            this.replayBtn.classList.add("hide");
        }
        if (this.player.paused) {
            this.player.play();
            this.playBtn.classList.add("hide");
            this.pauseBtn.classList.remove("hide");
            if (!preventFocus) {
                this.pauseBtn.focus();
            }
            if (this.allowIndicators && showIndicator) {
                this.pauseIndicator.classList.add("hide");
                this.playIndicator.classList.remove("hide");
                this.playIndicator.classList.add("fade-out");
                this.playIndicator.addEventListener("animationend", this.resetIndicator);
            }
            else {
                this.pauseIndicator.classList.add("hide");
                this.playIndicator.classList.add("hide");
            }
        }
        else {
            this.playIndicator.classList.add("hide");
            this.pauseIndicator.classList.remove("hide");
            this.player.pause();
            this.pauseBtn.classList.add("hide");
            this.playBtn.classList.remove("hide");
            if (!preventFocus) {
                this.playBtn.focus();
            }
            if (this.allowIndicators && showIndicator) {
                this.playIndicator.classList.add("hide");
                this.pauseIndicator.classList.remove("hide");
                this.pauseIndicator.classList.add("fade-out");
                this.pauseIndicator.addEventListener("animationend", this.resetIndicator);
            }
            else {
                this.pauseIndicator.classList.add("hide");
                this.playIndicator.classList.add("hide");
            }
        }
    };
    // show/hidden control buttons
    RMCPControlsElement.prototype.toggleVisibility = function (element1, element2) {
        if (element2 === void 0) {
            element2 = null;
        }
        // toggle between two elements
        if (element2 !== null) {
            if (element1.classList.contains("hide")) {
                element1.classList.remove("hide");
                element2.classList.add("hide");
                element1.focus();
            }
            else {
                element1.classList.add("hide");
                element2.classList.remove("hide");
                element2.focus();
            }
            // toggle single element
        }
        else {
            if (element1.classList.contains("hide")) {
                element1.classList.remove("hide");
                element1.focus();
            }
            else {
                element1.classList.add("hide");
            }
        }
    };
    // update the currentTime and currentTimeText
    RMCPControlsElement.prototype.updateCurrentTimeText = function () {
        var t = Math.round(this.player.getCurrentTime());
        this.currentTime = (0, utilities_js_1.formatTime)(t);
        this.currentTimeText.textContent = this.currentTime;
    };
    /*
     * applies action to end of video
     *  "stop": stops the video in the last frame and shows a large restart button.
     *  "stopNoReplayBtn": stops the video in the last frame without a large restart button.
     *  "loop": restarts and plays the video.
     *  "reset": resets the video to the initial state with the large play button.
     */
    RMCPControlsElement.prototype.onEnd = function (endAction) {
        var _a;
        switch (endAction) {
            case "stop":
            case "stopNoReplayBtn": {
                this.player.pause();
                this.player.goToFrame(this.player.getTotalFrames() - 1);
                // show large replay button
                if (endAction !== "stopNoReplayBtn") {
                    this.lrgReplayBtn.classList.remove("hide");
                }
                // show replay btn on controls
                this.replayBtn.classList.remove("hide");
                this.pauseBtn.classList.add("hide");
                this.playBtn.classList.add("hide");
                break;
            }
            case "loop": {
                this.player.pause();
                this.player.goToFrame(0);
                this.updateCurrentTimeText();
                this.player.play();
                break;
            }
            case "reset": {
                this.player.pause();
                this.player.goToFrame(0);
                this.updateCurrentTimeText();
                (_a = this.thumbnail) === null || _a === void 0 ? void 0 : _a.classList.remove("hide");
                this.playBtn.classList.remove("hide");
                this.pauseBtn.classList.add("hide");
                this.lrgPlayBtn.classList.remove("hide");
                break;
            }
        }
    };
    // replays video
    RMCPControlsElement.prototype.replay = function () {
        var _a, _b;
        this.player.goToFrame(0);
        this.updateCurrentTimeText();
        if (!((_a = this.thumbnail) === null || _a === void 0 ? void 0 : _a.classList.contains("hide"))) {
            (_b = this.thumbnail) === null || _b === void 0 ? void 0 : _b.classList.add("hide");
        }
        if (!this.lrgReplayBtn.classList.contains("hide")) {
            this.lrgReplayBtn.classList.add("hide");
        }
        this.replayBtn.classList.add("hide");
        this.pauseBtn.classList.remove("hide");
        this.player.play();
    };
    // update property this.endAction
    RMCPControlsElement.prototype.updateEndAction = function (action) {
        this.endAction = action;
    };
    // update slider handle aria-valuetext attribute when seekbar value changes
    RMCPControlsElement.prototype.updateSeekBarHandleARIAValueText = function (_currentTime, _duration) {
        // const ariaValueText = `${currentTime} of ${duration}`;
        // if (!this.seekBarHandle) this.seekBarHandle = this.querySelector(".rm-slider-handle");
        // this.seekBarHandle.setAttribute("aria-valuetext", ariaValueText);
    };
    // position the captions according to the controls visibility
    RMCPControlsElement.prototype.positionCaptions = function () {
        var hiddenTrue = this.playerControls.classList.contains("hidden");
        var height = hiddenTrue ? 0 : this.playerControls.offsetHeight;
        this.captions.style.bottom = "".concat(height, "px");
    };
    RMCPControlsElement.prototype.hideControlsOnTimeout = function () {
        var _this = this;
        clearTimeout(this.playerControlsTimer);
        if (this.hideControls) {
            this.playerControlsTimer = setTimeout(function () {
                if (_this.isSeeking)
                    return;
                if (!_this.captions.classList.contains("hide")) {
                    setTimeout(function () {
                        _this.positionCaptions();
                    }, 300);
                }
                _this.playerControls.classList.add("hidden");
                _this.playerControls.style.zIndex = "-1";
            }, this.playerControlsTimeout);
        }
    };
    RMCPControlsElement.prototype.showControls = function () {
        clearTimeout(this.playerControlsTimer);
        this.playerControls.classList.remove("hidden");
        this.playerControls.style.zIndex = "1";
        if (!this.captions.classList.contains("hide")) {
            this.positionCaptions();
        }
    };
    /*** CP-CONTROLS EVENT HANDLERS ***/
    // ensures the control features are maintained with keyboard accessibility
    RMCPControlsElement.prototype.handleControlsKeyDown = function (event) {
        var target = event.target;
        // prevents controls from being hidden while seekbar is navigated with keyboard
        if (target === this.seekBarHandle) {
            var keys = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown", "Left", "Right", "Up", "Down"];
            var keyFound = keys.indexOf(event.key);
            if (keyFound > -1) {
                this.showControls();
                this.hideControls = true;
                this.hideControlsOnTimeout();
            }
            if (!this.replayBtn.classList.contains("hide") && !this.lrgReplayBtn.classList.contains("hide")) {
                this.lrgReplayBtn.classList.add("hide");
                this.replayBtn.classList.add("hide");
                this.playBtn.classList.remove("hide");
            }
            // prevents the captions from moving behind the controls instead of hiding them
        }
        else if (target === this.captions) {
            if (event.key === " " || event.key === "Spacebar") {
                this.toggleVisibility(this.captions);
            }
            // removes the controls when video is played using keyboard unless video is paused
        }
        else if (target === this.pauseBtn) {
            if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
                this.hideControls = false;
                clearTimeout(this.playerControlsTimer);
            }
        }
        else {
            this.hideControls = true;
            this.hideControlsOnTimeout();
        }
    };
    // determines if the device is touchscreen to disable click on canvas to play
    RMCPControlsElement.prototype.handleTouchStart = function () {
        this.touchDevice = true;
    };
    // while the seekbar is in use, pause the video
    RMCPControlsElement.prototype.handleRmSliderDown = function () {
        this.hideControls = false;
        this.isSeeking = true;
        clearTimeout(this.playerControlsTimer);
        if (this.player.ended) {
            this.resumePlay = true;
        }
        else if (!this.player.paused) {
            this.resumePlay = true;
            this.togglePlay(true);
        }
        else {
            this.resumePlay = false;
        }
    };
    // when the seekbar is used, keep video, timestamp, and seekbar in sync
    RMCPControlsElement.prototype.handleRMSliderChange = function () {
        var _a, _b;
        var value = this.seekBar.value;
        this.ratio = value / this.seekBar.options.sections[1];
        // Keeps the current time indicator in sync with the seek bar handle.
        var newCurrentTime = (0, utilities_js_1.formatTime)(Math.round(this.ratio * this.duration));
        this.currentTimeText.textContent = newCurrentTime;
        // Keeps the video in sync with the seek bar handle.
        this.totalFrames = this.player.getTotalFrames() - 1;
        this.frame = Math.floor(this.ratio * this.totalFrames);
        if (!((_a = this.thumbnail) === null || _a === void 0 ? void 0 : _a.classList.contains("hide"))) {
            (_b = this.thumbnail) === null || _b === void 0 ? void 0 : _b.classList.add("hide");
        }
        if (this.frameStop) {
            if (this.frame >= this.frameStop) {
                this.throttleGoToFrame(this.frameStop);
                // this.seekBar.value = (this.frameStop / this.player.getTotalFrames()) * this.seekBar.options.sections[1];
            }
            else {
                this.throttleGoToFrame(this.frame);
            }
        }
        else {
            this.throttleGoToFrame(this.frame); // this.player.goToFrame() wrapped in throttle for efficiency
        }
    };
    // on release of the slider-handle, play the video
    RMCPControlsElement.prototype.handleRMSliderUp = function () {
        this.hideControls = true;
        this.isSeeking = false;
        this.totalFrames = this.player.getTotalFrames() - 1;
        if (this.frameStop) {
            if (this.frame >= this.frameStop) {
                this.seekBar.value = (this.frameStop / this.player.getTotalFrames()) * this.seekBar.options.sections[1];
            }
        }
        if (this.player.exportRoot.currentFrame >= this.totalFrames &&
            Number(this.seekBarHandle.getAttribute("aria-valuenow")) >=
                Number(this.seekBarHandle.getAttribute("aria-valuemax"))) {
            this.player.ended = true;
            this.onEnd(this.endAction);
        }
        else if (this.player.paused && this.resumePlay) {
            this.player.ended = false;
            this.resumePlay = false;
            this.togglePlay(true);
        }
    };
    // show controls when mouse moves anywhere on the video
    RMCPControlsElement.prototype.handleMouseMove = function () {
        this.showControls();
        // remove the controls after timeout
        if (document.activeElement !== this.seekBarHandle) {
            this.hideControlsOnTimeout();
        }
    };
    // remove controls when mouse leaves video
    RMCPControlsElement.prototype.handleMouseLeave = function () {
        if (document.activeElement !== this.seekBarHandle) {
            this.hideControlsOnTimeout();
        }
    };
    // show controls when focus is on the controls (keyboard accessiblity)
    RMCPControlsElement.prototype.handleFocusIn = function () {
        this.showControls();
        this.hideControlsOnTimeout();
    };
    // hide controls when focus leaves (keyboard accessiblity)
    RMCPControlsElement.prototype.handleFocusOut = function () {
        this.hideControlsOnTimeout();
    };
    // handle full screen toggle on double click (only when canvas is dbl clicked)
    RMCPControlsElement.prototype.handleDblClick = function () {
        if (this.fullScreenSupported) {
            clearTimeout(this.clickActionTimer);
            this.preventClickAction = true;
            this.player.toggleFullscreen();
            this.toggleVisibility(this.fullScreenBtn, this.exitFullScreenBtn);
        }
    };
    // handles all click actions for the cp-controls
    RMCPControlsElement.prototype.handleClick = function (event) {
        var _this = this;
        var target = event.target;
        // ensures the player plays correctly if the animation has ended but the user uses the seekbar instead of the replay button
        if (target.classList.contains("rm-slider") ||
            target.classList.contains("rm-slider-track") ||
            target.classList.contains("rm-slider-track-after") ||
            target.classList.contains("rm-slider-track-before") ||
            target.classList.contains("rm-slider-handle")) {
            if (!this.replayBtn.classList.contains("hide") && !this.lrgReplayBtn.classList.contains("hide")) {
                this.lrgReplayBtn.classList.add("hide");
                this.replayBtn.classList.add("hide");
                this.playBtn.classList.remove("hide");
            }
        }
        // clicking anywhere on the video will play/pause the video
        if (target.nodeName.toUpperCase() === "CANVAS") {
            if (this.touchDevice) {
                this.playerControls.classList.remove("hidden");
            }
            else {
                this.clickActionTimer = setTimeout(function () {
                    if (!_this.preventClickAction) {
                        _this.togglePlay(false, true);
                    }
                    _this.cpContainer.focus();
                    _this.preventClickAction = false;
                }, this.clickActionDelay);
            }
        }
        else if (target.classList.contains("cp-large-replay") || target.classList.contains("cp-replay")) {
            this.replay();
            this.cpContainer.focus();
        }
        else if (target.classList.contains("cp-play") || target.classList.contains("cp-large-play")) {
            if (this.frameStop && this.player.exportRoot.currentFrame >= this.frameStop)
                return;
            this.togglePlay();
            if (target.classList.contains("cp-large-play")) {
                this.cpContainer.focus();
            }
        }
        else if (target.classList.contains("cp-pause")) {
            this.togglePlay();
            if (target.classList.contains("cp-large-play")) {
                this.cpContainer.focus();
            }
        }
        else if (target.classList.contains("cp-show-captions") || target.classList.contains("cp-hide-captions")) {
            this.captionsEmpty = this.captions.innerText === "" ? true : false;
            if (this.captionsEmpty) {
                this.captions.classList.add("blank");
            }
            else {
                this.captions.classList.remove("blank");
            }
            this.toggleVisibility(this.captions);
            this.toggleVisibility(this.showCaptionsBtn, this.hideCaptionsBtn);
            if (!this.captions.classList.contains("hide")) {
                this.positionCaptions();
            }
        }
        else if (target.classList.contains("cp-transcript")) {
            var features = null;
            if (this.transcriptWindowFeatures === null) {
                var height = window.screen.availHeight / 2;
                var width = window.screen.availWidth / 2;
                features = {
                    resizable: 1,
                    scrollbars: 1,
                    top: window.screenTop + window.outerHeight / 2 - height / 2,
                    left: window.screenLeft + window.outerWidth / 2 - width / 2,
                    height: height,
                    width: width,
                };
            }
            else {
                features = this.transcriptWindowFeatures;
            }
            features = (0, utilities_js_1.getStringFromObject)(features);
            this.transcriptLoaded = false;
            // open new blank window with default descriptions
            if (this.transcriptHTMLUrl === "" && this.transcriptHTMLRef === null) {
                this.transcriptWindow = window.open(this.transcriptHTMLUrl, "_blank", features);
                this.descriptions.forEach(function (ts, index) {
                    if (ts.text !== undefined && ts.text !== "") {
                        if (index === 0) {
                            _this.transcriptWindow.document.body.appendChild(document.createElement("h1")).innerText =
                                "Video Transcript";
                            _this.transcriptWindow.document.body.appendChild(document.createElement("p")).innerText =
                                _this.formatTranscript(ts.text);
                        }
                        else if (ts.text !== _this.descriptions[index - 1].text) {
                            _this.transcriptWindow.document.body.appendChild(document.createElement("p")).innerText =
                                _this.formatTranscript(ts.text);
                        }
                    }
                });
                this.transcriptLoaded = true;
                // open new blank window with provided HTML Element(s) appended to body
            }
            else if (this.transcriptHTMLUrl === "" && this.transcriptHTMLRef !== null) {
                this.transcriptWindow = window.open(this.transcriptHTMLUrl, "_blank", features);
                if (Array.isArray(this.transcriptHTMLRef)) {
                    this.transcriptHTMLRef.forEach(function (element) {
                        var child = (0, utilities_js_1.cloneElement)(_this.transcriptWindow.document, element);
                        _this.transcriptWindow.document.body.appendChild(child);
                    });
                }
                else {
                    var child = (0, utilities_js_1.cloneElement)(this.transcriptWindow.document, this.transcriptHTMLRef);
                    this.transcriptWindow.document.body.appendChild(child);
                }
                this.transcriptLoaded = true;
                // open the provided HTML url in a new window
            }
            else if (this.transcriptHTMLUrl !== "" && this.transcriptHTMLRef === null) {
                this.transcriptWindow = window.open(this.transcriptHTMLUrl, "_blank", features);
                this.transcriptLoaded = true;
                // open the provided HTML url in a new window and append the HTML Element(s) to the body of the window or the specified container
            }
            else {
                var loadTranscriptContent_1 = function () {
                    if (_this.transcriptLoaded) {
                        return;
                    }
                    if (!_this.transcriptWindow.document.body) {
                        setTimeout(function () { return loadTranscriptContent_1(); }, 100);
                        return;
                    }
                    if (_this.transcriptHTMLRef !== null) {
                        if (Array.isArray(_this.transcriptHTMLRef)) {
                            _this.transcriptHTMLRef.forEach(function (element) {
                                var child = (0, utilities_js_1.cloneElement)(_this.transcriptWindow.document, element);
                                if (_this.transcriptHTMLContainerSelector) {
                                    _this.transcriptWindow.document.body
                                        .querySelector(_this.transcriptHTMLContainerSelector)
                                        .appendChild(child);
                                }
                                else {
                                    _this.transcriptWindow.document.body.appendChild(child);
                                }
                            });
                        }
                        else {
                            var child = (0, utilities_js_1.cloneElement)(_this.transcriptWindow.document, _this.transcriptHTMLRef);
                            if (_this.transcriptHTMLContainerSelector) {
                                _this.transcriptWindow.document.body
                                    .querySelector(_this.transcriptHTMLContainerSelector)
                                    .appendChild(child);
                            }
                            else {
                                _this.transcriptWindow.document.body.appendChild(child);
                            }
                        }
                    }
                    _this.transcriptLoaded = true;
                };
                this.transcriptWindow = window.open(this.transcriptHTMLUrl, "_blank", features);
                this.transcriptWindow.onload = function () {
                    if (!_this.transcriptLoaded) {
                        loadTranscriptContent_1();
                    }
                };
                /*
                 * IE11 runs window.open() as a synchronous task, preventing any further
                 * JavaScript from running until the window has opened and loaded, so the
                 * onload event that is declared afterwards is never fired because the new
                 * window has already "loaded". To get around this, check if the browser is
                 * IE11 and fire the load event again.
                 */
                if ((0, utilities_js_1.isIE)() && !this.transcriptLoaded) {
                    var loadTranscript_1 = function () {
                        if (!_this.transcriptWindow.document) {
                            setTimeout(function () { return loadTranscript_1(); }, 100);
                        }
                        else if (!_this.transcriptLoaded) {
                            loadTranscriptContent_1();
                        }
                    };
                    loadTranscript_1();
                }
            }
        }
        else if (target.classList.contains("cp-fullscreen") || target.classList.contains("cp-exit-fullscreen")) {
            this.player.toggleFullscreen();
            this.toggleVisibility(this.fullScreenBtn, this.exitFullScreenBtn);
        }
    };
    /*** END OF CP-CONTROLS EVENT HANDLERS ***/
    RMCPControlsElement.prototype.updateTranscript = function (buildHTML, HTMLContainer, HTMLUrl, windowFeatures) {
        if (buildHTML === void 0) {
            buildHTML = undefined;
        }
        if (HTMLContainer === void 0) {
            HTMLContainer = "";
        }
        if (HTMLUrl === void 0) {
            HTMLUrl = "";
        }
        if (windowFeatures === void 0) {
            windowFeatures = undefined;
        }
        if (buildHTML !== undefined) {
            this.transcriptHTMLRef = buildHTML();
        }
        this.transcriptHTMLContainerSelector = HTMLContainer;
        this.transcriptHTMLUrl = HTMLUrl;
        if (windowFeatures !== undefined) {
            this.transcriptWindowFeatures = windowFeatures;
        }
    };
    // connect controls to CanvasPlayer instance
    RMCPControlsElement.prototype.attachCanvasPlayer = function (cp) {
        var _this = this;
        this.player = cp;
        // hide full screen if browser doesn't support it
        if (!this.fullScreenSupported) {
            this.fullScreenBtn.classList.add("hide");
        }
        // once the animation is loaded
        this.player.on("canplay", function () {
            var _a, _b;
            //update video time stamp
            _this.duration = _this.player.getDuration();
            _this.durationText.textContent = (0, utilities_js_1.formatTime)(_this.duration);
            _this.updateCurrentTimeText(); // initializes this.currentTime and updates this.currentTimeText
            // get transcript
            _this.descriptions = _this.player.generateTranscript();
            // hide preloader and show the large play button
            _this.preloader.classList.add("hide");
            // if autoplay is true, don't show large play button
            if (_this.player.autoplay === true) {
                // this.toggleVisibility(this.playBtn, this.pauseBtn);
                (_a = _this.thumbnail) === null || _a === void 0 ? void 0 : _a.classList.add("hide");
                _this.lrgPlayBtn.classList.add("hide"); // Hide the lrg play button when autoplay is true
                _this.playBtn.classList.add("hide");
                _this.replayBtn.classList.add("hide");
                _this.pauseBtn.classList.remove("hide");
            }
            else {
                (_b = _this.thumbnail) === null || _b === void 0 ? void 0 : _b.classList.remove("hide");
                _this.lrgPlayBtn.classList.remove("hide");
            }
            // handles controls with keyboard
            _this.addEventListener("keydown", _this.handleControlsKeyDown);
            // determines if the device is touchscreen to disable click on canvas to play
            _this.cpContainer.addEventListener("touchstart", _this.handleTouchStart);
            // handles all click actions for the cp-controls
            _this.addEventListener("click", _this.handleClick);
            // ensures player is paused if user moves to another tab in the broswer and resumes playing when user returns to tab with video
            Focus.addFocusListener((function () {
                return function () {
                    if (Focus.isHidden()) {
                        _this.resumePlay = !_this.player.paused;
                        if (!_this.player.paused) {
                            _this.togglePlay();
                        }
                    }
                    else {
                        if (_this.resumePlay && _this.player.paused) {
                            _this.togglePlay();
                        }
                    }
                };
            })());
            // this.updateSeekBarHandleARIAValueText(this.currentTimeA11y, formatTimeA11y(this.duration));
            _this.seekBarHandle.setAttribute("aria-valuenow", "0");
        });
        /*** SEEKBAR EVENT HANDLERS ***/
        this.seekBar.setOptions(this.sliderOptions); // setup seekbar to jump frames
        // while the seekbar is in use, pause the video
        this.seekBar.addEventListener("rm-slider-down", this.handleRmSliderDown);
        // when the seekbar is used, keep video, timestamp, and seekbar in sync
        this.seekBar.addEventListener("change", this.handleRMSliderChange);
        // on release of the slider-handle, play the video
        this.seekBar.addEventListener("rm-slider-up", this.handleRMSliderUp);
        // update current time dynamically as the video plays
        this.player.on("timeupdate", function () {
            var _a, _b;
            if (!_this.isSeeking) {
                // Keeps the current time indicator in sync with the video.
                _this.updateCurrentTimeText();
                // fix for video contained in pop up (ensures player controls are shown correctly if user exits the video while it's playing)
                if (_this.player.paused && _this.currentTime === "0:00") {
                    if ((_a = _this.thumbnail) === null || _a === void 0 ? void 0 : _a.classList.contains("hide")) {
                        (_b = _this.thumbnail) === null || _b === void 0 ? void 0 : _b.classList.remove("hide");
                    }
                    if (_this.playBtn.classList.contains("hide") && _this.replayBtn.classList.contains("hide")) {
                        _this.playBtn.classList.remove("hide");
                        _this.pauseBtn.classList.add("hide");
                    }
                    if (_this.lrgPlayBtn.classList.contains("hide") && _this.lrgReplayBtn.classList.contains("hide")) {
                        _this.lrgPlayBtn.classList.remove("hide");
                    }
                }
                else if (_this.player.paused) {
                    _this.pauseBtn.classList.add("hide");
                    if (_this.player.ended) {
                        _this.replayBtn.classList.remove("hide");
                    }
                    else {
                        _this.playBtn.classList.remove("hide");
                    }
                }
                else if (!_this.player.paused && _this.pauseBtn.classList.contains("hide")) {
                    _this.playBtn.classList.add("hide");
                    _this.pauseBtn.classList.remove("hide");
                }
                /*
                 * Keeps the position of the handle on the seek bar in sync with
                 * the video.
                 */
                _this.ratio = _this.player.getCurrentTime() / _this.duration;
                _this.seekValue = _this.ratio * _this.seekBar.options.sections[1];
                _this.seekBar.value = Math.min(_this.seekBar.options.sections[1], _this.seekValue);
                /*
                 * Keeps the accessibility text of the handle on the seek bar in
                 * sync with the video.
                 */
                // this.updateSeekBarHandleARIAValueText(this.currentTimeA11y, formatTimeA11y(this.duration));
            }
        });
        /*** END OF SEEKBAR EVENT HANDLERS ***/
        /*** HANDLE SHOW/HIDE FOR CONTROLS ***/
        this.addEventListener("mousemove", this.handleMouseMove);
        // remove controls when mouse leaves video
        this.addEventListener("mouseleave", this.handleMouseLeave);
        // show controls when focus is on the controls (keyboard accessiblity)
        this.playerControls.addEventListener("focusin", this.handleFocusIn);
        // hide controls when focus leaves (keyboard accessiblity)
        this.playerControls.addEventListener("focusout", this.handleFocusOut);
        /*** END OF HANDLE SHOW/HIDE FOR CONTROLS ***/
        // handle full screen toggle on double click (only when canvas is dbl clicked)
        this.cpContainer.querySelector("canvas").addEventListener("dblclick", this.handleDblClick);
        // ensures controls are accessible in full screen mode
        this.player.on("fullscreenchange", function () {
            if (_this.player.isFullscreen()) {
                _this.ratio = _this.player.getCurrentTime() / _this.duration;
                _this.seekValue = _this.ratio * _this.seekBar.options.sections[1];
                // move controls to canvas player container
                _this.cpContainer.appendChild(_this.controlsContainer);
                _this.exitFullScreenBtn.focus();
                _this.fullScreenBtn.classList.add("hide");
                _this.exitFullScreenBtn.classList.remove("hide");
                // keeps the slider handle and current time at the same position
                setTimeout(function () {
                    _this.seekBar.value = Math.min(_this.seekBar.options.sections[1], _this.seekValue);
                }, 0);
            }
            else {
                _this.ratio = _this.player.getCurrentTime() / _this.duration;
                _this.seekValue = _this.ratio * _this.seekBar.options.sections[1];
                // move controls back to original position
                _this.appendChild(_this.controlsContainer);
                _this.fullScreenBtn.focus();
                _this.fullScreenBtn.classList.remove("hide");
                _this.exitFullScreenBtn.classList.add("hide");
                // keeps the slider handle and current time at the same position
                setTimeout(function () {
                    _this.seekBar.value = Math.min(_this.seekBar.options.sections[1], _this.seekValue);
                }, 0);
            }
        });
        // include captions
        this.player.on("captionChanged", function (event) {
            var showCaptions = event.detail.off === undefined || event.detail.off === null || event.detail.off === false
                ? true
                : false;
            _this.captions.innerText = showCaptions ? _this.formatTranscript(event.detail.text) : "";
            // captions only display when they exist, captions can be on and hidden at the same time using .blank
            if (_this.showCaptionsBtn.classList.contains("hide")) {
                if (_this.captions.innerText === "") {
                    _this.captions.classList.add("blank");
                    _this.captionsEmpty = true;
                }
                else {
                    _this.captions.classList.remove("blank");
                    _this.captionsEmpty = false;
                }
            }
        });
        // if the video ends, reset current time, set frame back to 0 and show play btn
        this.player.on("ended", function () {
            _this.player.ended = true;
            _this.onEnd(_this.endAction);
        });
        // resizing thumbnail and overlay when the canvas player resizes
        this.player.on("resizeEnd", function () {
            var _a = _this.player.canvas.getBoundingClientRect(), width = _a.width, height = _a.height;
            if (_this.thumbnail !== undefined && _this.thumbnail !== null) {
                _this.thumbnail.style.top = _this.player.canvas.style.top;
                _this.thumbnail.style.left = _this.player.canvas.style.left;
                _this.thumbnail.style.width = "".concat(width, "px");
                _this.thumbnail.style.height = "".concat(height, "px");
            }
        });
    };
    Object.defineProperty(RMCPControlsElement.prototype, "frameLimit", {
        /**
         * The following getter, setter, and clearFrameLimit() are used to set
         * a frameLimit when scrubbing with the slider. This is in cases when we
         * want to limit a user from scrubbing beyond a point (when there is a
         * selection in that particular frame)
         */
        get: function () {
            return this.frameStop;
        },
        set: function (frame) {
            if (frame >= 0 && frame < this.player.getTotalFrames()) {
                this.frameStop = frame;
            }
        },
        enumerable: false,
        configurable: true
    });
    RMCPControlsElement.prototype.clearFrameLimit = function () {
        this.frameStop = undefined;
    };
    // Added in case the canvas player is destroyed and rebuilt, event handlers aren't added twice to the player
    RMCPControlsElement.prototype.removeEventListeners = function () {
        this.removeEventListener("keydown", this.handleControlsKeyDown);
        this.removeEventListener("mousemove", this.handleMouseMove);
        this.removeEventListener("mouseleave", this.handleMouseLeave);
        this.removeEventListener("click", this.handleClick);
        if (this.seekBar) {
            this.seekBar.removeEventListener("rm-slider-down", this.handleRmSliderDown);
            this.seekBar.removeEventListener("change", this.handleRMSliderChange);
            this.seekBar.removeEventListener("rm-slider-up", this.handleRMSliderUp);
        }
        if (this.playerControls) {
            this.playerControls.removeEventListener("focusin", this.handleFocusIn);
            this.playerControls.removeEventListener("focusout", this.handleFocusOut);
        }
        if (this.cpContainer) {
            this.cpContainer.removeEventListener("touchstart", this.handleTouchStart);
        }
        var canvas = this.cpContainer.querySelector("canvas");
        if (canvas) {
            canvas.removeEventListener("dblclick", this.handleDblClick);
        }
    };
    return RMCPControlsElement;
}(custom_elements_1.HTMLCustomElement));
exports.default = RMCPControlsElement;
(0, custom_elements_1.registerElement)("rm-canvas-player-controls", RMCPControlsElement);
//# sourceMappingURL=module.js.map